// StyledCheckboxLabel.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledCheckboxLabelBase = styled.label`
  outline: none;
  font-size: ${({ styling }) => `${styling.checkboxLabelFontSize}px`};
  font-weight: ${({ styling }) => styling.checkboxLabelFontWeight};
  font-family: ${({ styling }) => styling.checkboxLabelFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  color: ${({ styling }) => styling.checkboxLabelColor};
`;

const StyledCheckboxLabel = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledCheckboxLabelBase {...props} placeholder={placeholderText} />;
};



export default StyledCheckboxLabel;
